module.exports = "/_next/static/images/13b78b233179a1265930eeb9762b3456-google-pay.png";